import { IAppConfigRootModel } from "../models/app-config-root.model";

export class AppConfigUtil {
	private static appConfigProperties: IAppConfigRootModel = null;

	public static getProperties(): IAppConfigRootModel {
		return AppConfigUtil.appConfigProperties;
	}

	public static setProperties(appConfig: IAppConfigRootModel): void {
		AppConfigUtil.appConfigProperties = appConfig;
	}
}
